import { FC, useMemo } from 'react'

import {
  MultiSelectFilter,
  MultiSelectFilterProps,
  TableColumnInstance,
} from '@revolut-internal/ui-kit-table'

import { AgentAttendanceFormattedData } from '../types'

type ShiftScheduleFilterProps = Omit<
  MultiSelectFilterProps,
  'active' | 'value' | 'options' | 'onChange'
> & {
  column: TableColumnInstance<AgentAttendanceFormattedData>
  agentAttendanceDetails: AgentAttendanceFormattedData[]
}

export const ShiftScheduleFilter: FC<ShiftScheduleFilterProps> = ({
  agentAttendanceDetails,
  column,
  ...restProps
}) => {
  const value = column.getFilterValue() as string[] | undefined
  const uniqueShifts = useMemo(
    () =>
      agentAttendanceDetails.reduce<string[]>((acc, row) => {
        if (!acc.includes(row.specialisation)) {
          acc.push(row.specialisation)
        }

        return acc
      }, []),
    [agentAttendanceDetails],
  )
  const options = useMemo(
    () =>
      uniqueShifts.map(shift => ({
        key: shift,
        label: shift,
        value: shift,
      })),
    [uniqueShifts],
  )

  return (
    <MultiSelectFilter
      active={Boolean(value)}
      value={value}
      options={options}
      searchable
      onChange={column.setFilterValue}
      {...restProps}
    />
  )
}
